export const Success = 1
export const Error = 0
export const Not_found = 2
export const Exist = 3
export const Warning = 4
